import { Map } from 'immutable';
import get from 'lodash/get';
import { createSelector } from 'reselect';

import { ArtistAllAlbumsSortTypes, emptyList, emptyMap } from './constants';
import * as D from './deps';

export function isValidPandoraId(str: $TSFixMe) {
  return D.Utils.Music.isOnDemandIdLike(str);
}

export function mapMusicIdsToPandoraIds(state: $TSFixMe, musicIdArray: $TSFixMe) {
  return musicIdArray.map((musicId: $TSFixMe) => {
    const artist = D.getArtistByMusicId(state, musicId);
    return artist && artist.has('pandoraId') && artist.get('pandoraId');
  });
}

export function getBackstageAnnotation(state: $TSFixMe, encryptedPandoraId: $TSFixMe) {
  const getAnnotations = D.getInDomain('catalog.utils.getAnnotations');
  const getAnnotationByShareableUrlPath = D.getInDomain(
    'catalog.utils.getAnnotationByShareableUrlPath',
  );
  const getAnnotationByEncryptedPandoraId = D.getInDomain(
    'catalog.utils.getAnnotationByEncryptedPandoraId',
  );
  let annotation = null;
  if (encryptedPandoraId) {
    annotation = getAnnotationByEncryptedPandoraId(state, encryptedPandoraId);
  }
  if (!annotation || annotation.isEmpty()) {
    const possiblePandoraId = D.getBackstagePandoraIdFromLocation(state);
    if (possiblePandoraId) {
      annotation = getAnnotations(state, possiblePandoraId);
    }
  }
  if (!annotation || annotation.isEmpty()) {
    const currentRoute = D.getCurrentPathnameFromState(state);
    annotation = getAnnotationByShareableUrlPath(state, currentRoute);
  }
  return annotation;
}

export function isBackstagePathUsingGraphQL(state: $TSFixMe, pathname: $TSFixMe) {
  const isBackstagePageUsingGraphQL =
    D.Utils.Route.isBackstageAlbumPath(pathname) ||
    D.Utils.Route.isBackstageAlbumChildPagePath(pathname) ||
    D.Utils.Route.isBackstageArtistPath(pathname);

  const isInitialAppLoad = D.getInDomain('application.utils.isInitialLoad', false)(state);
  return !isInitialAppLoad && isBackstagePageUsingGraphQL;
}

export function getCommonBackstageProps(
  state: $TSFixMe,
  encryptedPandoraId: $TSFixMe,
  pandoraId: $TSFixMe,
) {
  const props = {
    pandoraId,
    encryptedPandoraId,
    isListener: D.getInDomain('playback.utils.listenerHasStations', false)(state),
    onDemandIsEnabled: D.Utils.Listener.hasPremiumFeatures(state),
  };
  return props;
}

export function getValidFeaturedContentIds(state: $TSFixMe, ids = emptyList) {
  const validIds = ids.filter(id => {
    const annotation =
      // @ts-expect-error TS(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      D.getAnnotationsById(state, id) || D.Utils.Music.getPlaylistFromState(state, id);
    return annotation && annotation.get('pandoraId') && annotation.get('name');
  });

  return validIds.size === ids.size ? ids : validIds;
}

export function isBackstageRightRailActive(state: $TSFixMe) {
  return (
    D.getInDomain('ads.utils.getIsRightRailActive', false)(state) ||
    D.getInDomain('ads.utils.getIsElementCenteredWithAds', false)(state)
  );
}

export function getUserStationId(state: $TSFixMe, pandoraId: $TSFixMe) {
  const details = D.getInDomain('catalog.utils.getCatalogDetailsFromState')(state, pandoraId);
  const stationFactoryId = details.get('stationFactoryId', null);
  return (
    D.getInDomain('playback.utils.getStationIdFromStationFactoryId', null)(
      state,
      stationFactoryId,
    ) || D.getInDomain('playback.utils.getStationIdFromSeedPandoraId', null)(state, pandoraId)
  );
}

export const visibilitySettings = ({ isRowComponent, isGridComponent, useMemo }: $TSFixMe) => {
  return {
    staticHeight: isRowComponent && D.RowItemHeights.DEFAULT,
    offsets: isGridComponent && {
      bottom: -1 * D.Constants.Styling.GlobalStyleConstants.GRID_ITEM_FOOTER_HEIGHT,
    },
    useMemo,
  };
};

const getEntities = [
  D.Utils.Entity.getAllAnnotations,
  (state: $TSFixMe, pandoraId: $TSFixMe) =>
    D.getInDomain('catalog.utils.getCatalogDetailsFromState')(state, pandoraId),
];

export const getValidListIds =
  (listProp: $TSFixMe) => (annotations: $TSFixMe, details: $TSFixMe) => {
    const list = details ? details.get(listProp, emptyList) : emptyList;
    return list.filter((id: $TSFixMe) => {
      const annotation = annotations.get(id);
      return annotation && annotation.get('pandoraId') && annotation.get('name');
    });
  };

// @ts-expect-error TS(2345) FIXME: Argument of type '((state: any, pandoraId: any) =>... Remove this comment to see the full error message
export const getTopAlbums = createSelector(getEntities, getValidListIds('topAlbums'));
// @ts-expect-error TS(2345) FIXME: Argument of type '((state: any, pandoraId: any) =>... Remove this comment to see the full error message
export const getTopTracks = createSelector(getEntities, getValidListIds('topTracks'));
// @ts-expect-error TS(2345) FIXME: Argument of type '((state: any, pandoraId: any) =>... Remove this comment to see the full error message
export const getFeaturedContent = createSelector(getEntities, getValidListIds('featuredBy'));
// @ts-expect-error TS(2345) FIXME: Argument of type '((state: any, pandoraId: any) =>... Remove this comment to see the full error message
export const getSimilarArtists = createSelector(getEntities, getValidListIds('similarArtists'));

export const getArtistAllAlbumsSortedIds = createSelector(
  D.Utils.Entity.getAllAnnotations,
  (state, pandoraId) => {
    return D.getInDomain('catalog.utils.getArtistDiscographyFromState')(state, pandoraId);
  },
  (annotations, discography) => {
    const annotatedAlbums = discography.filter((albumId: $TSFixMe) => {
      return annotations.get(albumId, emptyMap).size;
    });

    const sortedAlbums = annotatedAlbums.groupBy((albumId: $TSFixMe) => {
      return annotations.get(albumId, emptyMap).get('listenerReleaseType');
    });

    return Map({
      [ArtistAllAlbumsSortTypes.All]: annotatedAlbums,
      [ArtistAllAlbumsSortTypes.Album]: sortedAlbums.get(ArtistAllAlbumsSortTypes.Album, emptyList),
      [ArtistAllAlbumsSortTypes.Single]: sortedAlbums.get(
        ArtistAllAlbumsSortTypes.Single,
        emptyList,
      ),
      [ArtistAllAlbumsSortTypes.Compilation]: sortedAlbums.get(
        ArtistAllAlbumsSortTypes.Compilation,
        emptyList,
      ),
    });
  },
);

export const compareByAtoZ = (a: $TSFixMe, b: $TSFixMe) => {
  const titleA = get(a, 'name', '').toUpperCase();
  const titleB = get(b, 'name', '').toUpperCase();
  if (titleA === titleB) {
    return 0;
  }
  return titleA > titleB ? 1 : -1;
};

export const compareByRecents = (a: $TSFixMe, b: $TSFixMe) => {
  const dateTimeA = get(a, 'modificationTime', '');
  const dateTimeB = get(b, 'modificationTime', '');
  if (dateTimeA === dateTimeB) {
    return 0;
  }
  return dateTimeA > dateTimeB ? -1 : 1;
};

export const isClean = (content: $TSFixMe) =>
  get(content, 'explicitness', null) === D.getInDomain('catalog.constants.Explicitness.CLEAN');

export const isExplicit = (content: $TSFixMe) =>
  get(content, 'explicitness', null) === D.getInDomain('catalog.constants.Explicitness.EXPLICIT');
